const content = `<p>Expressive code means code that shows the intent of its author.</p>

<p>Code that is expressive is <a href="/ease-of-change">easy to change</a> because reading it shows the right places to make the changes.</p>

<p>Conversely, it's hard to change code that's not expressive because it's not obvious where to make the changes, and changes make it even less expressive.</p>

<p>Most techniques to make code expressive come down to respecting <a href="/levels-of-abstraction">levels of abstraction</a>, and have good naming (article to come).</p>

<p>Moreover, there are language-specific techniques to make code expressive. For example in C++ have a look at <a href="https://www.fluentcpp.com">Fluent C++</a> <i>[ressources wanted for other languages]</i>.</p>`;

export default content;
